import { useState, useEffect } from "react";
import Header from "../../common/layout/header";
import Footer from "../../common/layout/footer";
import Sidebar from "../../common/sidebar";
import RichTextEditor from "../../common/richTextEditor";
import { BaseUrl } from "../../common/config";
import { http } from "../../helper";
import CommonAlert from "../../common/Commonalert";
import ShowAlert from "../../common/Showalert";
import { useTranslation, Trans } from "react-i18next";
import { canAction } from "../../common/permissionhelper";
const MODULE = "manage_foodservicepartners";
const EMAIL_TYPE = "vendor_verification";
const VendorAuthEmail = () => {
  const { t } = useTranslation();
  const canEdit = canAction(MODULE, "edit");
  const isReadOnly = !canEdit;
  const [templateId, setTemplateId] = useState(null);
  const [emailSubject, setEmailSubject] = useState("");
  const [emailContent, setEmailContent] = useState("");
  const [header, setHeader] = useState(true);
  const [footer, setFooter] = useState(true);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertErrorPopup, setAlertErrorPopup] = useState(false);
  const [alertErrorMessage, setAlertErrorMessage] = useState("");
  // AUTH CHECK
  if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
  const authData = JSON.parse(sessionStorage.getItem("authData"));
  if (
    authData &&
    !authData.adminRole.permissions.includes("manage_foodservicepartners")
  ) {
    window.location.href = "/unauthorized";
  }
  // Fetch existing template
  useEffect(() => {
    setIsLoading(true);
    http
      .get(BaseUrl + "admin/emailConfigs")
      .then((res) => {
        const list = res.data.data || [];
        const verificationTemplate = list.find(
          (t) => t.emailType === EMAIL_TYPE
        );
        if (verificationTemplate) {
          setTemplateId(verificationTemplate._id);
          setEmailSubject(verificationTemplate.emailSubject || "");
          setEmailContent(verificationTemplate.emailContent || "");
          setHeader(verificationTemplate.header ?? true);
          setFooter(verificationTemplate.footer ?? true);
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, []);
  // Handlers
  const handleChangeEmailContent = (value) => {
    setEmailContent(value);
    setErrors((prev) => ({ ...prev, emailContent: "" }));
  };
  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };
  const validate = () => {
    const err = {};
    let valid = true;
    if (!emailSubject.trim()) {
      err.emailSubject = t("field_require_txt");
      valid = false;
    }
    if (!stripHtml(emailContent).trim()) {
      err.emailContent = t("field_require_txt");
      valid = false;
    }
    setErrors(err);
    return valid;
  };
  // Submit
  const handleSubmit = async () => {
    e.preventDefault();
    if (isReadOnly) return;
    if (!validate()) return;
    const payload = {
      templateName: "Vendor Email Verification",
      emailType: "vendor_verification",
      emailSubject,
      emailContent,
      header,
      footer,
    };
    try {
      setIsLoading(true);
      if (templateId) {
        //UPDATE
        await http.put(BaseUrl + "admin/editEmailConfig", {
          id: templateId,
          ...payload,
        });
      } else {
        // CREATE (first time only)
        await http.post(BaseUrl + "admin/emailConfig", payload);
      }
      setAlertMessage(t("email_template_saved_success_txt"));
      setAlertPopup(true);
      // success alert
    } catch (err) {
      console.log(err);
      setAlertErrorMessage(t("email_template_saved_faild_txt"));
      setAlertErrorPopup(true);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <section className="dashboard-block">
      {alertPopup && (
        <CommonAlert 
          title={t("alert_txt")} 
          message={alertMessage} 
          onClose={() => {
            setAlertPopup(false);
            setAlertMessage("");
          }}
        />
      )}
      {alertErrorPopup && (
        <ShowAlert title={t("alert_txt")} message={alertErrorMessage} />
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container account-details">
            <h1 className="checkout-title">
              {t("vendor_email_template_txt")}
            </h1>
            <div className="right-table-outer-wrap">
              {isLoading ? (
                <div className="loading-buffer"></div>
              ) : (
                <form className="sectors-detail-form">
                  {/* Subject */}
                  <div className="input-field">
                    <label>{t("email_subject_txt")}</label>
                    <input
                      type="text"
                      value={emailSubject}
                      onChange={(e) => {
                        setEmailSubject(e.target.value);
                        setErrors((prev) => ({
                          ...prev,
                          emailSubject: "",
                        }));
                      }}
                      readOnly={isReadOnly}
                    />
                    {errors.emailSubject && (
                      <div className="error-msg">{errors.emailSubject}</div>
                    )}
                  </div>
                  {/* Header / Footer */}
                  <div className="input-field">
                    <label>{t("included_txt")}</label>
                    <div className="full-text-toggle custom_check-box">
                      <div className="check-box">
                        <input
                          type="checkbox"
                          id="header"
                          checked={header}
                          onChange={(e) => {
                            if (isReadOnly) return;
                            setHeader(e.target.checked);
                          }}
                        />
                        <label htmlFor="header">{t("add_header_txt")}</label>
                        &nbsp;&nbsp;&nbsp;
                        <input
                          type="checkbox"
                          id="footer"
                          checked={footer}
                          onChange={(e) => {
                            if (isReadOnly) return;
                            setFooter(e.target.checked);
                          }}
                        />
                        <label htmlFor="footer">{t("add_footer_txt")}</label>
                      </div>
                    </div>
                  </div>
                  {/* Content */}
                  <div className="input-field">
                    <label>{t("email_content_txt")}</label>
                    <div className="note-text">
                      <Trans i18nKey="auth_verify_dynamic_note" components={{ code: <code /> }} />
                    </div>
                    <br />
                    <div className="email-editor-wrapper">
                      <RichTextEditor
                        emailContent={emailContent}
                        handleChangeEmailContent={handleChangeEmailContent}
                        readOnly={isReadOnly}
                      />
                    </div>
                    {errors.emailContent && (
                      <div className="error-msg">{errors.emailContent}</div>
                    )}
                  </div>
                  {!isReadOnly && (
                  <div className="btnfield">
                    <button type="button" onClick={handleSubmit}>
                      {t("submit_txt")}
                    </button>
                  </div>
                  )}
                </form>
              )}
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </section>
  );
};

export default VendorAuthEmail;